import React from "react";
import clsx from "clsx";
interface StripeInputWrapperProps {
  children: React.ReactNode;
  error: string;
  icon?: React.ReactNode;
  labelText: string;
}

export const StripeInputWrapper = ({ children, error, icon, labelText }: StripeInputWrapperProps) => {
  const wrapperClasses = clsx(
    "border max-h-[32px] rounded-sm px-3 py-[7px] bg-white rounded-sm border-neutral-300 hover:border-neutral-500 focus-within:outline-solid focus-within:border-platform-600 outline-1 outline-platform-600/10",
    error && "border-red-700",
    icon && "grid grid-cols-[35px_1fr]"
  );
  return (
    <div className="mb-4">
      <label className="pb-2 m-0 text-xs font-semibold leading-5">{labelText}</label>
      <div className={wrapperClasses}>
        {icon}
        {children}
      </div>
      {error && <p className="pt-1 m-0 text-xs font-normal leading-5 text-red-700">{error}</p>}
    </div>
  );
};
